import axios from "axios";

// NOTE Currently just a simple wrapper, but eventually, this can be extended, e.g.
// - apply a caching layer

export function getData(resourcePath, queryParams = {}) {
  return axios.get(resourcePath, { params: queryParams });
}

export function deleteData(resourcePath) {
  return axios.delete(resourcePath);
}

export function submitData(url, data, method = "post") {
  return axios({ url, data, method });
}

// See https://github.com/pburtchaell/redux-promise-middleware/blob/master/docs/guides/rejected-promises.md
export function catchHttpError(error) {
  if (error.response) {
    // is an axios http error
    // must be catched, but nothing to do: state will be handled by reducer
  } else {
    throw error; // ensure non-ajax errors bubble up
  }
}
